import { createApiActions } from 'iqvia-shared';

import { getLocale, getMessages, loadLocaleData } from '../localization';
import { LOCALIZATION_URL } from '../constants';
import apiNameEnums from '../../../Enums/apiNames';

export const fetchLocalization = locale =>
  createApiActions(apiNameEnums.GET_LOCALIZATION, {
    url: LOCALIZATION_URL.replace('{locale}', locale),
    actionTypeOverrides: {
      success: {
        payload: (action, state, response) =>
          response.json().then(jsonData => {
            window.App.localizationInfo = jsonData;
            loadLocaleData();

            return {
              locale: getLocale(),
              messages: getMessages(),
            };
          }),
      },
    },
  });



// WEBPACK FOOTER //
// ./src/Shared/CustomIntlProvider/actions/index.js